// @flow

import styled from 'styled-components';
import { SPACING_EXTRA_EXTRA_LARGE } from 'styles/spacing';
import media from 'styles/media-queries';

export const Row = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  padding: ${SPACING_EXTRA_EXTRA_LARGE} 0;

  ${media.small`
    flex-direction: row;
  `};
`;

export default Row;



// WEBPACK FOOTER //
// ./src/components/payer/canceled/styles.js